import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const RemixIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="12" viewBox="0 0 23 12" fill="none">
    <path
      d="M12.5546 5.04307L13.9828 3.62948C15.5172 2.1107 17.9898 2.11194 19.5242 3.63072V3.63072C21.0798 5.17035 21.081 7.68476 19.5255 9.2244V9.2244C17.9904 10.7438 15.5175 10.7415 13.9852 9.2194L8.36546 3.63698C6.83314 2.11484 4.36023 2.11261 2.82517 3.63198V3.63198C1.26963 5.17161 1.27091 7.68602 2.82644 9.22566V9.22566C4.36091 10.7444 6.83343 10.7457 8.36789 9.2269L9.79608 7.81331"
      stroke="currentColor"
    />
    <path d="M15.5303 4.94141L12.5725 4.94141L12.5725 2.01391" stroke="currentColor" />
    <path d="M6.65527 7.87402L9.613 7.87402L9.613 10.8015" stroke="currentColor" />
  </svg>,
  'remix'
);
